// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_TransactionHistoryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /contas/contas/transaction_history/{conta_id}
 *
 * Fetches transaction history. No body required — conta_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Contas_TransactionHistoryInput {}

registerContract('Contas_TransactionHistoryInput', {})
